<script lang="ts" setup>
import { inject, ref, watch } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';
import ToggleBox from '@/components/ToggleBox.vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const meshFreezeToggle = ref<boolean>(manifest.value.meshFreezeOptimization ?? true);
const worldMatrixFreezeToggle = ref<boolean>(manifest.value.worldMatrixFreezeOptimization ?? true);
const materialFreezeToggle = ref<boolean>(manifest.value.materialFreezeOptimization ?? true);
const hideSmallMeshesToggle = ref<boolean>(manifest.value.hideSmallMeshesOptimization ?? true);

watch(meshFreezeToggle, (newValue) => {
  manifest.value.meshFreezeOptimization = newValue;
});

watch(worldMatrixFreezeToggle, (newValue) => {
  manifest.value.worldMatrixFreezeOptimization = newValue;
});

watch(materialFreezeToggle, (newValue) => {
  manifest.value.materialFreezeOptimization = newValue;
});

watch(hideSmallMeshesToggle, (newValue) => {
  manifest.value.hideSmallMeshesOptimization = newValue;
});

watch(manifest, (newValue) => {
  meshFreezeToggle.value = newValue.meshFreezeOptimization ?? true;
  worldMatrixFreezeToggle.value = newValue.worldMatrixFreezeOptimization ?? true;
  materialFreezeToggle.value = newValue.materialFreezeOptimization ?? true;
  hideSmallMeshesToggle.value = newValue.hideSmallMeshesOptimization ?? true;
});
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      Optimizations
    </template>

    <div class="flex flex-col mb-1 last-of-type:mb-0">
      <ToggleBox v-model="meshFreezeToggle" label="Mesh Freeze" />
    </div>

    <div class="flex flex-col mb-1 last-of-type:mb-0">
      <ToggleBox v-model="worldMatrixFreezeToggle" label="World Matrix Freeze" />
    </div>

    <div class="flex flex-col mb-1 last-of-type:mb-0">
      <ToggleBox v-model="materialFreezeToggle" label="Material Freeze" />
    </div>

    <div class="flex flex-col mb-1 last-of-type:mb-0">
      <ToggleBox v-model="hideSmallMeshesToggle" label="Hide Small Meshes" />
    </div>
  </CollapseFieldset>
</template>
